import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["type", "src", "size", "highlight", "highlightWidth", "className", "href", "hideBorder"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx } from 'clsx';
import { AvatarFallbackIcon } from '../AvatarFallbackIcon';
import { isCompanyAvatarType } from '../../helpers';
import styles from './styles.module.css';
import { colorToValue } from '../../../../internal/utils/colorToValue';
import { OptionalAnchor } from '../../../../internal/components/OptionalAnchor';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Компонент аватарки
 *
 * Люди - круглые
 * Компании - квадратные
 */
export const InternalAvatar = /*#__PURE__*/React.forwardRef(function InternalAvatar(_ref, ref) {
  let {
      type,
      src,
      size,
      highlight,
      highlightWidth,
      className,
      href,
      hideBorder = false
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const [errorSrc, setErrorSrc] = React.useState(null);
  const isFallback = !src || errorSrc === src;
  const isCompany = isCompanyAvatarType(type);
  const isClickable = !!(href || rest.onClick);
  const handleError = () => {
    setErrorSrc(src || null);
  };
  return /*#__PURE__*/_jsxs(OptionalAnchor, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    className: clsx(className, styles['avatar'], isCompany && styles['company'], isClickable && styles['clickable'], !hideBorder && styles['border']),
    style: {
      width: size,
      height: size,
      boxShadow: highlight ? "0 0 0 ".concat(highlightWidth, "px ").concat(colorToValue(highlight)) : undefined
    },
    href: href,
    children: [isFallback && /*#__PURE__*/_jsx(AvatarFallbackIcon, {
      type: type
    }), !isFallback && /*#__PURE__*/_jsx("img", {
      src: src,
      onError: handleError,
      decoding: "async"
    })]
  }));
});